import { useSyncExternalStore } from 'react';

// Match the CSS mobile breakpoint, including short touch screens after rotation.
export const MOBILE_QUERY =
  '(max-width: 760px), (max-width: 1000px) and (max-height: 500px) and (pointer: coarse)';

// one MediaQueryList per query: getSnapshot runs on every render of every subscriber (tables re-render on each move)
// (keyed by the matchMedia function too: tests swap window.matchMedia between cases)
const lists = new Map<string, MediaQueryList>();
let listsOf: unknown = null;
function listOf(query: string): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  if (listsOf !== window.matchMedia) {
    lists.clear();
    listsOf = window.matchMedia;
  }
  let mq = lists.get(query);
  if (!mq) {
    try {
      mq = window.matchMedia(query);
    } catch {
      return null;
    }
    lists.set(query, mq);
  }
  return mq;
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mq = listOf(query);
      if (!mq) return () => undefined;
      mq.addEventListener?.('change', cb);
      return () => mq.removeEventListener?.('change', cb);
    },
    () => listOf(query)?.matches ?? false,
    () => false,
  );
}

/** Phone layout (390px design). */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}
